import Clube from './Clube.js';
import Arbitro from './Arbitro.js';
import * as generic from './generic.js';
import React, { Fragment } from 'react';

export default function TabelaLine(props) {
	const item = props.item || {};

	const showPlacar = props.aovivo ? (item.id_periodo !== "4" && item.id_periodo !== "15") : (item.id_periodo === "5");

	return (
	<div onClick={props.onClick} className="line row" style={props.onClick ? { cursor: "pointer" } : {}}>
		<div className="column e100 line-data">
			<div className="datahora">
				{props.showPeriodo ?
					(item.id_periodo === "7" ?
						<span style={{color: "red"}}>Adiado</span>
					: 
						(item.id_periodo === "15" ?
							<span style={{color: "red"}}>Suspenso</span>
						:
							<span>{item.periodo_jogo}</span>
						)
					)
				:
					<>
					<span> {generic.fmtDataHora(item.datahora, "A definir")}</span> &mdash;&nbsp;
					<span className="cidade">{item.cidade}</span>
					{item.id_periodo === "7" ?
						<> &mdash; <span style={{color: "red"}}>Adiado</span></>
					: 
						(item.id_periodo === "15" ?
							<> &mdash; <span style={{color: "red"}}>Suspenso</span></>
						:
							(showPlacar && item.id_periodo !== "4" && item.periodo_jogo ? <> &mdash; <span>{item.periodo_jogo}</span></> : null)
						)
					}
					</>
				}
			</div>
			<div className="row">
				<Clube clube={item.id_clubem} clubeMap={props.clubeMap} className="e30 mandante"/>
				<div className="row placar">
					<span className="e30 placar_tn placarm">{
						showPlacar ?
							<>
								{item.penaltis === "S" ? <span className="penalti">{item.placarm_pe}</span> : null}
								{item.prorrogacao === "S" ? <span className="prorrogacao">{item.placarm_pr}</span> : null}
								{item.placarm_tn}
							</>
						:
							"\u00a0"
					}</span>
					<span className="e0 placar_x">X</span>
					<span className="e30 placar_tn placarv">{
						showPlacar ?
							<>
								{item.placarv_tn}
								{item.prorrogacao === "S" ? <span className="prorrogacao">{item.placarv_pr}</span> : null}
								{item.penaltis === "S" ? <span className="penalti">{item.placarv_pe}</span> : null}
							</>
						:
							"\u00a0"
					}</span>

				</div>
				<Clube clube={item.id_clubev} clubeMap={props.clubeMap} className="e30 visitante"/>
			</div>
			{props.hasInfo ? (
				<div className="info" data-selected={item === props.selectedLine}>
					<div>
						<span className="estadio">Estádio: {item.estadio}</span>
					</div>
					{item.arbitro ? (
						<div className="list-arbitro">
							{item.arbitro.principal ? <span>Árbitro: <Arbitro arbitro={item.arbitro.principal}/></span> : null}
							{item.arbitro.quarto ? <span>Quarto árbitro: <Arbitro arbitro={item.arbitro.quarto}/></span> : null}
							{item.arbitro.auxiliar1 && item.arbitro.auxiliar2 ?
								(<span>Auxiliares: <Arbitro arbitro={item.arbitro.auxiliar1}/> e <Arbitro arbitro={item.arbitro.auxiliar2}/></span>)
							: 
								(item.arbitro.auxiliar1 ?
									<span>Auxiliar: <Arbitro arbitro={item.arbitro.auxiliar1}/></span>
								:
									item.arbitro.auxiliar2 ?
										<span>Auxiliar: <Arbitro arbitro={item.arbitro.auxiliar2}/></span>
									:
										null
								)
							}
						</div>
					) : null}
					{item.observacoes ? (<><div className="observacao">{item.observacoes}</div></>) : null}
				</div>
			) : null}
		</div>
		{props.hasPublico ?
			<div className="line-stats">
				<div className="column line-stats-clubes">
					<Clube clube={item.id_clubem} clubeMap={props.clubeMap} className="e30 mandante"/>
					<span className="placar_x">X</span>
					<Clube clube={item.id_clubev} clubeMap={props.clubeMap} className="e30 visitante"/>
				</div>
				<div className={"number large"}>{generic.fmtNumber(item.pu)}</div>
				<div className={"number large"}>{generic.fmtNumber(item["in"])}</div>
				<div className="number percent">{generic.fmtPercent(item.iv)}</div>
				<div className={"number currency"}>
					<div className="column">
						<span>{generic.fmtCurrency(item.rl_mandante)}</span>
						{parseFloat(item.rl_visitante || 0) ? <span>{generic.fmtCurrency(item.rl_visitante)}</span> : null}
					</div>
				</div>
				<div className={"number currency"}>{generic.fmtCurrency(item.rb)}</div>
			</div>
		:
			null
		}
	</div>
	);
}
